(function() {
'use strict';

const TR = angular.module('TR');
TR.directive('tooltip', function() {
    return {
        restrict: 'A',
        scope: {
            placement: '@'
        },
        link(scope, el, attr) {
            if (TRPCONFIG.IsTouchDevice) {
                return;
            }

            let popup;

            const placement = (() => {
                switch (scope.placement) {
                    case 'start': return TRPCONFIG.Rtl ? 'right' : 'left';
                    case 'end': return TRPCONFIG.Rtl ? 'left' : 'right';
                    default: return scope.placement || 'top';
                }
            })();

            el.on('mouseenter', function() {
                if (!attr.tooltip) {
                    return;
                }

                if (!popup) {
                    el.trppopup({
                        trigger: 'manual',
                        placement,
                        content() {
                            return attr.tooltip;
                        }
                    });
                    popup = el.data('trppopup');
                }

                popup.show();
            });
            el.on('mouseleave', function() {
                if (popup) {
                    popup.hide();
                }
            });

            scope.$on('$destroy', function() {
                el.off('mouseenter');
                el.off('mouseleave');
                if (popup) {
                    popup.destroy();
                }
            });
        }
    };
});
})();
